import { Routes } from "@angular/router";

export const AppRoutes: Routes = [
  {
    path: "",
    loadComponent: () =>
      import("./features/home/home.component").then((m) => m.HomeComponent),
    title: "blu.africa — Studio Digital Panafricain • Paris • Dakar • Abidjan",
  },
  {
    path: "vision",
    loadComponent: () =>
      import("./features/vision/vision.component").then(
        (m) => m.VisionComponent
      ),
    title: "Notre Vision — blu.africa | Studio Digital Panafricain",
  },
  {
    path: "services",
    loadComponent: () =>
      import("./features/services/services.component").then(
        (m) => m.ServicesComponent
      ),
    title: "Nos Services — blu.africa | Développement Web, Mobile & IA",
  },
  {
    path: "pourquoi",
    loadComponent: () =>
      import("./features/pourquoi/pourquoi.component").then(
        (m) => m.PourquoiComponent
      ),
    title:
      "Pourquoi blu.africa — Notre Différence | Studio Digital Panafricain",
  },
  {
    path: "contact",
    loadComponent: () =>
      import("./features/contact/contact.component").then(
        (m) => m.ContactComponent
      ),
    title: "Contact — blu.africa | Démarrer votre projet",
  },
  {
    path: "blog",
    loadComponent: () =>
      import("./features/blog/blog.component").then((m) => m.BlogComponent),
    title: "Blog — blu.africa | Studio Digital Panafricain",
  },
  {
    path: "blog/studio-digital-panafricain",
    loadComponent: () =>
      import(
        "./features/blog/articles/studio-digital-panafricain/studio-digital-panafricain.component"
      ).then((m) => m.StudioDigitalPanafricainComponent),
    title:
      "Pourquoi blu.africa ? L'histoire d'un Studio Digital Panafricain — blu.africa",
  },
  {
    path: "blog/produit-tech-afrique",
    loadComponent: () =>
      import(
        "./features/blog/articles/produit-tech-afrique/produit-tech-afrique.component"
      ).then((m) => m.ProduitTechAfriqueComponent),
    title:
      "Comment créer un produit tech adapté au marché africain — blu.africa",
  },
  {
    path: "blog/tech-afrique-2026",
    loadComponent: () =>
      import(
        "./features/blog/articles/tech-afrique-2025/tech-afrique-2025.component"
      ).then((m) => m.TechAfrique2025Component),
    title:
      "2026 : L'année où l'Afrique prend le contrôle de sa tech — blu.africa",
  },
  {
    path: "**",
    redirectTo: "",
  },
];
